import CustomerInfoCard from 'components/CustomerInfoCard';
import useLeadCustomer from './useLeadCustomer';

const LeadCustomer: React.FunctionComponent = function ({}) {
  const { customer, isLoading } = useLeadCustomer();
  return <CustomerInfoCard customer={customer} isLoading={isLoading} />;
};

export default LeadCustomer;
